import { Component, OnInit, AfterViewInit, Renderer2, Injectable, Inject, OnDestroy } from '@angular/core';
import { TITLEHEADER, TITLEHEADER_BOLD, ROLES } from '../app/common/constants/labels';
import { environment } from './../environments/environment';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, CanDeactivate } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { AuthError, CryptoUtils, Logger } from 'msal';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
/* Application loads with authentication */
export class AppComponent implements OnInit, OnDestroy {
  title = 'QAMatrix';
  loading = true;
  loggedIn: boolean;
  public userInfo: any = null;
  public isIframe: boolean;
  private subscription: Subscription;
  private adalConfiguration = {
    tenant: environment.tenant,
    clientId: environment.clientId,
    redirectUri: environment.endpoints,
    navigateToLoginRequestUrl: false,
    cacheLocation: 'sessionStorage'
  };
  constructor(private router: Router, private renderer: Renderer2, private broadcastService: BroadcastService, private authService: MsalService) {
    if (window.localStorage.length === 0) {
      this.router.navigateByUrl(environment.msalAuthConfig.auth.redirectUri);
    } else if (localStorage.getItem('msal.error') === 'login_required') {
      window.localStorage.clear();
      this.loggedIn = false;
    }
    if (this.authService.getAccount()) {
      this.loggedIn = true;
    } else {
      this.loggedIn = false;
    }
  }
  ngOnInit() {
    if (this.loggedIn === true) {
      this.checkoutADAccount();
    } else if (this.loggedIn === false) {
      this.login();
    }

    this.broadcastService.subscribe('msal:loginFailure', payload => {
      this.loggedIn = false;
      this.login();
    });

    this.broadcastService.subscribe('msal:loginSuccess', () => {
      this.loggedIn = false;
    });

    this.authService.handleRedirectCallback((redirectError: AuthError, response) => {
      if (redirectError) {
        return;
      }
    });

    this.authService.setLogger(new Logger((logLevel, message, piiEnabled) => {
    }, {
      correlationId: CryptoUtils.createNewGuid(),
      piiLoggingEnabled: false
    }));

  }


  async checkoutADAccount() {
    if (this.loggedIn) {
      // To renew idToken, please pass clientId as the only scope
      // const accessTokenRequest = {
      //   scopes: ['user.read'],
      // };
      const accessTokenRequest = {
        scopes: [environment.msalAuthConfig.auth.clientId],
      };
      const userAccount = this.authService.getAccount();
      let role = '';
      this.authService.acquireTokenSilent(accessTokenRequest).then(async (payload: any) => {
        localStorage.setItem('factory', userAccount.idToken.city);
        localStorage.setItem('UserEmailAddress', userAccount.userName);
        localStorage.setItem('UserName', userAccount.idToken.name);
        localStorage.setItem('Token', payload.idToken.rawIdToken);
        payload.idTokenClaims.roles.forEach(r => {
        for ( const appRole of ROLES) {
            if (appRole === r) {
              role = r;
              break;
            }
          }
        });
        localStorage.setItem('role', role);
      }).catch((error) => {
        console.log(error);
      });
      this.router.events.subscribe((event) => {
        switch (true) {
          case event instanceof NavigationStart: {
            this.loading = true;
            break;
          }
          case event instanceof NavigationEnd: {
            this.loading = false;
            break;
          }
          case event instanceof NavigationCancel:
          case event instanceof NavigationError: {
            this.loading = false;
            break;
          }
          default: {
            break;
          }
        }
      });
    }
  }

  login() {
    this.authService.loginRedirect();
  }
  ngOnDestroy() {
    this.broadcastService.getMSALSubject().next(1);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
